import { render } from "./Timer.vue?vue&type=template&id=178d73ad&scoped=true"
import script from "./Timer.vue?vue&type=script&lang=js"
export * from "./Timer.vue?vue&type=script&lang=js"

import "./Timer.vue?vue&type=style&index=0&id=178d73ad&lang=scss&scoped=true"

import exportComponent from "/Users/oleksandrpolishchuk/Documents/dev/eye-test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178d73ad"]])

export default __exports__